import { FacilityOptions } from '../../../../../core/models/options/facility-options';
import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { LaasOption } from 'src/app/core/models/laas-option';
import { FacilityService } from 'src/app/core/services/facility.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';

export interface tableInterface {
  optionCode: string;
  optionDesc: string;
  commonAttr01: string;
}

export interface tableDataInterface {
  rowName: string;
  EXW: string;
  FCA: string;
  CPT: string;
  CIP: string;
  DAP: string;
  DPU: string;
  DDP: string;
  FAS: string;
  FOB: string;
  CFR: string;
  CIF: string;
}

@Component({
  selector: 'laas-shipterm-description',
  templateUrl: './shipterm-description.component.html',
  styleUrls: ['./shipterm-description.component.scss']
})
export class ShipTermDescriptionComponent extends SessionBaseComponent implements OnInit {

  isVisible: boolean;

  forwarderDescriptionList: tableInterface[] | null;
  anyForwarderList: tableInterface[];
  shipForwarderList: tableInterface[];
  firstAnyForwarder: tableInterface | null;
  firstShipForwarder: tableInterface | null;
  anyForwarderCount: number;
  shipForwarderCount: number;

  headerList: string[];
  dataTableList: string[];
  dataList: tableDataInterface[];

  constructor(injector: Injector, private facilityService: FacilityService) {
    super(injector);

    this.isVisible = false;

    this.forwarderDescriptionList = [];
    this.anyForwarderList = [];
    this.shipForwarderList = [];
    this.firstAnyForwarder = null;
    this.firstShipForwarder = null;
    this.anyForwarderCount = 0;
    this.shipForwarderCount = 0;

    this.headerList = ['EXW','FCA','CPT','CIP','DAP','DPU','DDP','FAS','FOB','CFR','CIF'];
    this.dataTableList = ['rowName', 'EXW','FCA','CPT','CIP','DAP','DPU','DDP','FAS','FOB','CFR','CIF'];
    this.dataList = this.pushTableData();
  }

  @Input() get visible(): any {
    return this.isVisible;
  }

  @Output() visibleChange = new EventEmitter<any>();

  set visible(value: any) {
    this.isVisible = value;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.facilityService.getAllFacilityOptionsByOptionType("INCOTERMS").subscribe({
      next: (result: any) => {
        this.forwarderDescriptionList = [...result].map((x: any) => {
          return {
            optionCode: `${x.optionCode}`,
            optionDesc: x.optionDesc,
            commonAttr01: x.commonAttr01
          };
        });
        if (this.forwarderDescriptionList != null) {
          this.doSplitList(this.forwarderDescriptionList);
        }
        console.log(this.forwarderDescriptionList);
        console.log(this.anyForwarderList);
        console.log(this.shipForwarderList);
      }
    })

  }

  dialogVisibleChange(value: boolean): void {
    this.visibleChange.emit(value);
  }

  doSplitList(totalList: tableInterface[]) {

    totalList.forEach( (value) =>{
      if (value.commonAttr01 == 'ANY') {
        this.anyForwarderList.push(value);
      } else {
        this.shipForwarderList.push(value);
      }
    })
    this.anyForwarderCount = this.anyForwarderList.length;
    this.shipForwarderCount = this.shipForwarderList.length;
    this.firstAnyForwarder = this.anyForwarderList[0];
    this.firstShipForwarder = this.shipForwarderList[0];
    this.anyForwarderList.shift();
    this.shipForwarderList.shift();
  }

  defiendColor(fieldValue: string): string {
    switch (fieldValue) {
      case 'ForwarderDesc.Buyer': {
        return 'rowRed'
      }
      case 'ForwarderDesc.Deal': {
        return 'rowYellow'
      }
      case 'ForwarderDesc.Seller': {
        return 'rowBillred'
      }
      default: {
        return 'rowDefault'
      }
    }
  }

  pushTableData(): tableDataInterface[] {
    let tableData = [
    {rowName:'ForwarderDesc.RowName.PickUpLoad', EXW:'ForwarderDesc.Buyer', FCA:'ForwarderDesc.Seller', CPT:'ForwarderDesc.Seller', CIP:'ForwarderDesc.Seller', DAP:'ForwarderDesc.Seller', DPU:'ForwarderDesc.Seller', DDP:'ForwarderDesc.Seller', FAS:'ForwarderDesc.Seller', FOB:'ForwarderDesc.Seller', CFR:'ForwarderDesc.Seller', CIF:'ForwarderDesc.Seller'},
    {rowName:'ForwarderDesc.RowName.DeliverToPortOrPoint', EXW:'ForwarderDesc.Buyer', FCA:'ForwarderDesc.Seller', CPT:'ForwarderDesc.Seller', CIP:'ForwarderDesc.Seller', DAP:'ForwarderDesc.Seller', DPU:'ForwarderDesc.Seller', DDP:'ForwarderDesc.Seller', FAS:'ForwarderDesc.Seller', FOB:'ForwarderDesc.Seller', CFR:'ForwarderDesc.Seller', CIF:'ForwarderDesc.Seller'},
    {rowName:'ForwarderDesc.RowName.ExportDeclaration', EXW:'ForwarderDesc.Buyer', FCA:'ForwarderDesc.Seller', CPT:'ForwarderDesc.Seller', CIP:'ForwarderDesc.Seller', DAP:'ForwarderDesc.Seller', DPU:'ForwarderDesc.Seller', DDP:'ForwarderDesc.Seller', FAS:'ForwarderDesc.Seller', FOB:'ForwarderDesc.Seller', CFR:'ForwarderDesc.Seller', CIF:'ForwarderDesc.Seller'},
    {rowName:'ForwarderDesc.RowName.ExportPort', EXW:'ForwarderDesc.Buyer', FCA:'ForwarderDesc.Buyer', CPT:'ForwarderDesc.Seller', CIP:'ForwarderDesc.Seller', DAP:'ForwarderDesc.Seller', DPU:'ForwarderDesc.Seller', DDP:'ForwarderDesc.Seller', FAS:'ForwarderDesc.Seller', FOB:'ForwarderDesc.Seller', CFR:'ForwarderDesc.Seller', CIF:'ForwarderDesc.Seller'},
    {rowName:'ForwarderDesc.RowName.PortAirport', EXW:'ForwarderDesc.Buyer', FCA:'ForwarderDesc.Buyer', CPT:'ForwarderDesc.Seller', CIP:'ForwarderDesc.Seller', DAP:'ForwarderDesc.Seller', DPU:'ForwarderDesc.Seller', DDP:'ForwarderDesc.Seller', FAS:'ForwarderDesc.Buyer', FOB:'ForwarderDesc.Seller', CFR:'ForwarderDesc.Seller', CIF:'ForwarderDesc.Seller'},
    {rowName:'ForwarderDesc.RowName.Freight', EXW:'ForwarderDesc.Buyer', FCA:'ForwarderDesc.Buyer', CPT:'ForwarderDesc.Seller', CIP:'ForwarderDesc.Seller', DAP:'ForwarderDesc.Seller', DPU:'ForwarderDesc.Seller', DDP:'ForwarderDesc.Seller', FAS:'ForwarderDesc.Buyer', FOB:'ForwarderDesc.Buyer', CFR:'ForwarderDesc.Seller', CIF:'ForwarderDesc.Seller'},
    {rowName:'ForwarderDesc.RowName.Insurance', EXW:'ForwarderDesc.Deal', FCA:'ForwarderDesc.Deal', CPT:'ForwarderDesc.Deal', CIP:'ForwarderDesc.Seller', DAP:'ForwarderDesc.Deal', DPU:'ForwarderDesc.Deal', DDP:'ForwarderDesc.Deal', FAS:'ForwarderDesc.Deal', FOB:'ForwarderDesc.Deal', CFR:'ForwarderDesc.Deal', CIF:'ForwarderDesc.Seller'},
    {rowName:'ForwarderDesc.RowName.DestinationPortAirport', EXW:'ForwarderDesc.Buyer', FCA:'ForwarderDesc.Buyer', CPT:'ForwarderDesc.Seller', CIP:'ForwarderDesc.Seller', DAP:'ForwarderDesc.Seller', DPU:'ForwarderDesc.Seller', DDP:'ForwarderDesc.Seller', FAS:'ForwarderDesc.Buyer', FOB:'ForwarderDesc.Buyer', CFR:'ForwarderDesc.Buyer', CIF:'ForwarderDesc.Buyer'},
    {rowName:'ForwarderDesc.RowName.DeliveryToDestination', EXW:'ForwarderDesc.Buyer', FCA:'ForwarderDesc.Buyer', CPT:'ForwarderDesc.Buyer', CIP:'ForwarderDesc.Buyer', DAP:'ForwarderDesc.Seller', DPU:'ForwarderDesc.Seller', DDP:'ForwarderDesc.Seller', FAS:'ForwarderDesc.Buyer', FOB:'ForwarderDesc.Buyer', CFR:'ForwarderDesc.Buyer', CIF:'ForwarderDesc.Buyer'},
    {rowName:'ForwarderDesc.RowName.DestinationUnloading', EXW:'ForwarderDesc.Buyer', FCA:'ForwarderDesc.Buyer', CPT:'ForwarderDesc.Buyer', CIP:'ForwarderDesc.Buyer', DAP:'ForwarderDesc.Buyer', DPU:'ForwarderDesc.Seller', DDP:'ForwarderDesc.Buyer', FAS:'ForwarderDesc.Buyer', FOB:'ForwarderDesc.Buyer', CFR:'ForwarderDesc.Buyer', CIF:'ForwarderDesc.Buyer'},
    {rowName:'ForwarderDesc.RowName.ImportDutiesAndClearance', EXW:'ForwarderDesc.Buyer', FCA:'ForwarderDesc.Buyer', CPT:'ForwarderDesc.Buyer', CIP:'ForwarderDesc.Buyer', DAP:'ForwarderDesc.Buyer', DPU:'ForwarderDesc.Buyer', DDP:'ForwarderDesc.Seller', FAS:'ForwarderDesc.Buyer', FOB:'ForwarderDesc.Buyer', CFR:'ForwarderDesc.Buyer', CIF:'ForwarderDesc.Buyer'}]

    return tableData

  }
}
